import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItem as RmwcListItem} from '@rmwc/list'
import '@rmwc/list/styles'

const theme = ({theme}) => css`
  .mdc-theme--on-${theme} &&&.mdc-list-item--selected,
  .mdc-theme--on-${theme} &&&.mdc-list-item--activated {
    color: var(--mdc-theme-secondary5);
  }

  .mdc-theme--on-${theme} &&&.mdc-list-item--activated {
    background-color: var(--mdc-theme-secondary2);
  }

  .mdc-theme--on-${theme} :not(.mdc-list--non-interactive) > &&&:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple::before,
  .mdc-theme--on-${theme} :not(.mdc-list--non-interactive) > &&&:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple::after {
    opacity: 0;
  }

  .mdc-theme--on-${theme} :not(.mdc-list--non-interactive) > &&&:not(.mdc-list-item--disabled).mdc-list-item:hover .mdc-list-item__ripple::before {
    opacity: 0.05;
  }

  .mdc-theme--on-${theme} :not(.mdc-list--non-interactive) > &&&:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple::before,
  .mdc-theme--on-${theme} :not(.mdc-list--non-interactive) > &&&:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple::after {
    background-color: var(--mdc-theme-on-${theme});
  }
`

export const listItemStyles = css`
  &&& {
    height: 3rem;
    margin: 1rem 1rem;
    padding: 0 1rem;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    border-radius: 8px;
  }
  .mdc-list--dense &&& {
    height: 2rem;
    margin: 0;
    padding: 0;
  }
  .mdc-list--two-line &&& {
    height: 72px;
  }
  &&&:nth-last-child(1) {
    margin-bottom: 0;
  }
  .mdc-theme--on-primary2 &&&:not(.mdc-list-item--activated) {
    color: var(--mdc-theme-on-primary2, #fff);
  }
  .rmwc-collapsible-list__children-inner &&& {
    margin: 0.5rem 1rem 0.5rem 3.5rem;
  }
  .rmwc-collapsible-list__children-inner &&&:nth-child(1) {
    margin-top: 0.25rem;
  }
  .rmwc-collapsible-list__children-inner &&&:nth-last-child(1) {
    margin-bottom: 0;
  }
  ${theme({theme: 'primary'})};
  ${theme({theme: 'primary2'})};
`

const StyledRmwcListItem = styled(RmwcListItem)`
  ${listItemStyles}
`

const ListItem = ({children, ...otherProps}) => <StyledRmwcListItem {...otherProps}>{children}</StyledRmwcListItem>

ListItem.propTypes = {
  children: PropTypes.any
}

export {ListItem}
